//============================================================================
// Name        : sidebar_v2.ts
// Purpose     : Implement inventory page sidebar v2 logic
// Created     : 2021-01-21
// Author      : AliReza Mohagheghi
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import * as QueryString from "query-string";
import { SeTreeview } from "../controls/se_treeview";
import { InitPage } from "../index";

declare var inventoryUrl: string;
declare var loadCategoriesUrl: string;
declare var inventoryStatsUrl: string;
declare var inventoryCountCategories: string;

declare var paramsObj: object;

interface IInventoryStats {
  total_count: number;
  item_count: number;
  excluded_skus: number;
  zones: { id: any; count: number }[];
  status: { id: number; count: number }[];
  item_types: { id: number; count: number }[];
}

function loadProps(): void {
  const treeview = new SeTreeview();

  treeview.setListCounter("categories", async () => {
    try {
      const { data } = await axios.get(`${inventoryCountCategories}.json`);

      const updateCounters = (cats: any[] = []) => {
        cats.forEach((cat) => {
          const el = $(".categories-list")
            .find(`[data-record-id='${cat.id}']`)
            .find("div");
          el.html(` (${cat.count})`);
          el.parent().data("count", cat.count);
          updateCounters(cat.children);
        });
      };

      updateCounters(data);
      treeview.countFinished("categories");
    } catch {
      window.showErrorDialog("Error getting inventory stats");
    }
  });

  const loadCounts = async () => {
    try {
      const resp = await axios.get(inventoryStatsUrl, {
        params: { ...(paramsObj as any), stats_count: true },
      });
      const stats: IInventoryStats = resp.data;
      $("#totalItemInventoryCount").text(stats.excluded_skus);
    } catch {
      window.showErrorDialog("Error getting inventory stats");
    }
  };

  setTimeout(() => {
    loadCounts();
    treeview
      .loadNodes("categories", `${loadCategoriesUrl}.json`)
      .then(() => treeview.setCheckedNodes("categories"));
  }, 1000);

  // Restore filters if applicable
  const currentFilters = QueryString.parse(location.search);
  delete (currentFilters as any).utf8;

  let savedFiltersStr = localStorage.getItem("inventoryFilters");
  if (
    Object.keys(currentFilters).length <= 2 &&
    savedFiltersStr &&
    !location.search.includes("antenna_id")
  ) {
    const savedFilters = QueryString.parse(savedFiltersStr);
    delete (savedFilters as any).utf8;

    if (!("search" in currentFilters)) {
      delete (savedFilters as any).search;
    } else if (!location.search.includes("filter")) {
      (savedFilters as any).search = (currentFilters as any).search;
      (savedFilters as any).multilocation = (
        currentFilters as any
      ).multilocation;
    }

    savedFiltersStr = QueryString.stringify(savedFilters);
    if (savedFiltersStr) location.search = savedFiltersStr;
  }

  // Persist new filters (excluding search and multilocation)
  const toSave = { ...currentFilters } as Record<string, unknown>;
  delete toSave.search;
  delete toSave.multilocation;
  if (Object.keys(toSave).length > 1) {
    localStorage.setItem("inventoryFilters", location.search);
  }

  // Handle clearing inventory filters
  $(".clear-filters").on("click", () => {
    localStorage.removeItem("inventoryFilters");
    location.href = inventoryUrl;
  });

  window.onbeforeunload = () => {
    window.onunload = () => {
      window.localStorage.removeItem("inventoryFilters");
    };
  };
}

export function LoadPage() {
  [
    "manage_exclusions",
    "ns_manage_exclusions",
    "vend_manage_exclusions",
  ].forEach((id) => InitPage(id, loadProps));
}
